export enum AmenitiesAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_AMENITIES_LIST = "ADD_AMENITIES_LIST",
    UPDATE_AMENITIES_LIST = "UPDATE_AMENITIES_LIST",
    UPDATE_AMENITIES_SEARCH_REQ = "UPDATE_AMENITIES_SEARCH_REQ",
    SET_UPDATE_AMENITIES = "SET_UPDATE_AMENITIES",
}